import { Component, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-ice-pill',
  templateUrl: './ice-pill.component.html',
  styleUrls: ['./ice-pill.component.scss'],
  imports: [],
})
export class IcePillComponent {
  @Input() type: 'neutral' | 'info' | 'primary' | 'blank' = 'neutral';
  @Input() isDisabled = false;
  @Input() cursor = 'pointer';
  @Input() isInteractive = true;

  @HostBinding('class')
  get hostClasses(): string {
    return `ice-pill ${this.type}-pill ${this.isDisabled ? 'pill-disabled' : ''}`;
  }
  @HostBinding('style.pointerEvents')
  get pointerEvents() {
    return this.isInteractive && !this.isDisabled ? 'auto' : 'none';
  }
  @HostBinding('style.cursor')
  get hostCursor() {
    return this.cursor;
  }
}
